module.exports = __webpack_public_path__ + "img/22.13421337.svg";